import CacheGroup from '@/modules/common/enums/cache-group.ts';
import { TypeCode } from '@/modules/common/enums/type-code.ts';
import { useCacheStore } from '@/modules/core/stores/cache.store.ts';
import { useMasterFormStore } from '@/modules/document/stores/master-form.ts';
import { defineStore, storeToRefs } from 'pinia';
import { computed, type InjectionKey, type Ref } from 'vue';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';
import type { WizardNestedParent } from '@/wizard/nested-session.ts';

export const DOCUMENT_MASTER_HOST_KEY: InjectionKey<WizardNestedParent> = Symbol('documentMasterHost');

export const useDocumentMasterStore = defineStore(StoreId.DocumentMaster, {
  state: () => ({
    isOpen: false,
  }),
  actions: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
  },
});

export function useDocumentMaster() {
  const store = useDocumentMasterStore();
  const { isOpen } = storeToRefs(store);

  return {
    isOpen,
    open: () => store.open(),
    close: () => store.close(),
  };
}

export function resetDocumentMasterData() {
  useCacheStore().remove({ group: CacheGroup.DocumentMaster });
  useMasterFormStore().$reset();
}

export function resetDocumentMaster() {
  resetDocumentMasterData();
  useDocumentMasterStore().close();
}

export function useDocumentMasterDirty(page: Ref<number>) {
  const masterFormStore = useMasterFormStore();

  return computed(
    () => page.value > 0 || masterFormStore.type.code !== TypeCode.Document || masterFormStore.project !== null
  );
}
